import { FmdGood, Person, Phone } from "@mui/icons-material";
import { Divider, Link as A, Stack, Typography, Paper } from "@mui/material";
import { txt } from "../../../services/translation";
import frenchCountries from "../../../config/frenchCountries";


export default function Cards({data}){


    return (
        <Stack direction='row' flexWrap='wrap'>
            <Card title={txt('profile')} icon={<Person color='action'/>}>
                <Typography variant='span'>{txt('sectorPoint')} {txt(data.category?.id)}</Typography>
                <Typography variant='span'>{txt('companyPoint')} {data.company?.name}</Typography>
                {frenchCountries.includes(data.country) && <>
                    <Typography variant='span'>{txt('statusPoint')} {data.status?.title}</Typography>
                    <Typography variant='span'>{txt('rppsPoint')} {data.rpps || txt('notProvided')}</Typography>
                </>}
            </Card>
    
            <Card title={txt('address')} icon={<FmdGood color='action'/>}>
                <Typography variant='span'>{data.address || txt('addressUnknown')}</Typography>
                <Typography variant='span'>{data.zip || txt('zipUnknown')}</Typography>
                <Typography variant='span'>{data.city || txt('cityUnknown')}</Typography>
            </Card>
    
            <Card title={txt('contact')} icon={<Phone color='action'/>}>
                <Typography variant='span'>
                    <A href={`mailto:${data.email}`}>{data.email}</A>
                </Typography>
                <Typography variant='span'>
                    <A href={`tel:${data.phone}`}>{data.phone}</A>
                </Typography>
                <Typography variant='span'>
                    <A href={`tel:${data.phone2}`}>{data.phone2}</A>
                </Typography>
            </Card>
        </Stack>
    );
    
}

function Card({title, icon, children}){

    const sx = {
        minWidth: 230,
        minHeight: 140,
        p: 1,
        mr: 1.5,
        mb: 1,
    }

    return <Paper variant='outlined' sx={sx}>

        <Stack spacing={1}>

            <Stack direction='row' spacing={1} alignItems='center'>

                {icon}

                <Typography>{title}</Typography>

            </Stack>

            <Divider />

            <Stack spacing={1}>

                {children}

            </Stack>
            
        </Stack>
    </Paper>
}